module.exports = __webpack_public_path__ + "d1a82a09a3091c35a072dea72986bd46.png";


//////////////////
// WEBPACK FOOTER
// ./src/theme-files/image-resources/pattern-bg/pattern-bg-2.png
// module id = 406
// module chunks = 0